import Field from './field'
import { useForm, useWatch } from 'react-hook-form'
import { useFormControl } from 'hooks/useFormControl.hook'
import { conformToMask } from 'react-text-mask'
import { useCookie } from 'hooks/useCookie.hook'
import './style.scss'
import { useEffect, useRef, useState } from 'react'
import { useClientRequest } from 'hooks/useClientRequest.hook'
import Modal from 'components/modal'
import Loader from 'components/loader'
import { useService } from 'hooks/useService.hook'

export const patterns = {
    tel: { value: /^[+]7 [(][0-9]{3}[)] [0-9]{3}[-][0-9]{2}[-][0-9]{2}$/, message: 'Введите корректный телефон' },
    mail: { value: /^[a-zA-Z0-9._%+-]+@[A-Za-z0-9.-]*.[a-zA-Z]{2,4}$/, message: 'Введите корректный email' },
}

const UTMLIST = ['UTM_SOURCE', 'UTM_MEDIUM', 'UTM_CAMPAIGN', 'UTM_CONTENT', 'UTM_TERM'];

const PHONE_AND_EMAIL_AUTOSEARCH = false

export const telMask = () => {
    const mask = '+7 (###) ###-##-##'
    return mask.split('').map((x) => {
        return x !== '#' ? x : /\d/
    })
}

const topLevelPropsToLowercase = (obj) => {
    if (typeof obj !== 'object' || obj === null) {
        return obj
    }

    return Object.keys(obj).reduce((newObj, key) => {
        const lowerKey = key.toLowerCase()
        newObj[lowerKey] = obj[key] // Keep original value (no recursion)
        return newObj
    }, {})
}

function Form(
    {
        successText,
        initialScheme,
        id,
        defaultValues: initialDefaultValues,
        popup,
        tilda,
        containerEl,
        wrapperEl,
        formSubTitle,
        formTitle,
        formPopupSubTitle,
        formPopupTitle,
        tildaAgreement,
        pageIntegrateFormAgreement,
        fullFormPageAgreement,
        isFullPageForm
    }) {
    const namesForWatching = initialScheme
        .filter((x) => x.UF_SEARCH_CONTACTS)
        .map(({ UF_PRE_FILL_CODE, UF_MASK, name }) => ({ mask: UF_MASK, name, code: UF_PRE_FILL_CODE }))
    const ref = useRef()
    const { getContactIdByPhone, getContactIdByMail, getCompanyByContactId } = useService()
    const { scheme = [], onSubmit, submitLoading, setScheme } = useFormControl({ initialScheme })
    scheme.sort((a, b) => {
        if (a.UF_AUTO_SEARCH && !b.UF_AUTO_SEARCH) {
            return 1
        } else {
            return 0
        }
    })
    const [defaultValues, setDefaultValues] = useState(initialDefaultValues)


    const [candidate, setCandidate] = useState(null)
    const [company, setCompany] = useState(null)
    const [isHiddenFields, setIsHiddenFields] = useState(PHONE_AND_EMAIL_AUTOSEARCH ? !defaultValues?.length :false)
    const useFormContext = useForm({ mode: 'onChange' })
    const { getCookie } = useCookie()
    const [modal, setModal] = useState(false)
    const { handleSubmit, setValue, watch, reset, subscribe, getFieldState, getValues } = useFormContext

    const isTildaPopup = popup && tilda


    //Выбор текста для чекбокса соглашения
    const baseAgreementText = `Я подтверждаю, что я старше 18 лет, принимаю условия работы портала и даю добровольное согласие на обработку своих персональных данных. Подробнее: <a href="https://profi.erzrf.ru/polzovatelskoe-soglashenie/">https://profi.erzrf.ru/polzovatelskoe-soglashenie/</a>`
    let checkboxHtml = baseAgreementText

    if(tilda) {
        //Для форм на страницах Tilda
        checkboxHtml = tildaAgreement || baseAgreementText
    } else if(isFullPageForm) {
        //Для отдельной страницы с формой
        checkboxHtml = fullFormPageAgreement || baseAgreementText
    } else if (!tilda && !isFullPageForm) {
        //Для формы, интегрированной на страницах (не Tilda)
        checkboxHtml = pageIntegrateFormAgreement || baseAgreementText
    }

    const closeTildaPopup = () => {
        if (!isTildaPopup || !containerEl) return
        const tildaPopup = containerEl.closest('.t-popup')
        if (tildaPopup) {
            tildaPopup.classList.remove('t-popup_show')
            tildaPopup.style.display = 'none'
        }
    }

    const onSubmitHandler = async (ev) => {
        const ufCookies = getCookie('ufCookies')
        const { id: candidateId } = candidate || {}
        const { id: companyId } = company || {}
        const {
            result: { DEAL_ID },
        } = await onSubmit({
            data: ev,
            formValues: {
                FORM_ID: id,
                ...(ufCookies && { UF_COOKIES: getCookie('ufCookies') }),
                ...(candidateId && { UF_PRE_FILL_CONTACT_ID: candidateId }),
                ...(companyId && { UF_PRE_FILL_COMPANY_ID: companyId }),
                ...getUtmFromUrl(),
            },
        })
        reset()
        if (DEAL_ID) {
            setModal(true)
            // Закрываем Tilda popup после успешной отправки формы
            if (isTildaPopup) {
                closeTildaPopup()
            }
        } else {
            alert('something went wrong')
        }
    }

    const getFieldByName = (name) => namesForWatching.find((x) => x.name === name)

    const getCandidate = async ({ phone, email }) => {
        let data

        phone = phone && phone.replaceAll(/[()\+\- ]/g, '')

        if (phone) {
            try {
                data = await getContactIdByPhone({ phone, scheme: id })
            } catch (error) {}
        }

        if (email) {
            try {
                data = await getContactIdByMail({ email, scheme: id })
            } catch (error) {}
        }

        if (data?.length === 1) {
            // const items = await getContactById(data[0])
            setDefaultValues(data)
            setIsHiddenFields(false)
            return { unsubscribe: true }
        } else if (email) {
            setIsHiddenFields(false)
        }

        return {}
    }

    const getCandidateByEmail = () => {
        const { name: emailName } = namesForWatching.find((x) => x.code == 'EMAIL')
        const { invalid } = getFieldState(emailName)
        if (!invalid) {
            const email = getValues(emailName)
            getCandidate({ email })
        }
    }

    const getMainCompany = (data) => {
        // let items = Object.values(data.result)
        // items = items.map((x) => ({ ...x.item }))
        //   return items.find((x) => x.ufCrm_1637937027683.includes(1544)) || items[0]

        return data.find((x) => x.ufCrm_1637937027683.includes(1544)) || data[0]
    }

    const autoFill = ({ candidate, requisite, company }) => {
        let target = {}
        const getPrefilledValues = () => {
            const result = []

            const getSortedFm = ({ typeId, arr }) => {
                switch (typeId) {
                    case 'PHONE':
                        return arr
                            .filter((x) => x.typeId === 'PHONE')
                            .sort((a, b) => {
                                if (a.valueType === b.valueType) return 0
                                if (a.valueType === 'MOBILE') return -1
                                if (b.valueType === 'MOBILE') return 1
                                return 0
                            })
                    case 'EMAIL':
                        return arr
                            .filter((x) => x.typeId === 'EMAIL')
                            .sort((a, b) => {
                                if (a.valueType === b.valueType) return 0
                                if (a.valueType === 'WORK') return -1
                                if (b.valueType === 'WORK') return 1
                                return 0
                            })
                    case 'WEB':
                        return arr
                            .filter((x) => x.typeId === 'WEB')
                            .sort((a, b) => {
                                if (a.valueType === b.valueType) return 0
                                if (a.valueType === 'WORK') return -1
                                if (b.valueType === 'WORK') return 1
                                return 0
                            })
                }
            }
            const getFmProps = (target = []) => {
                return target.reduce((acc, curr, _, arr) => {
                    let { typeId } = curr
                    const [{ value } = {}] = getSortedFm({ typeId, arr }) || []
                    if (value) {
                        acc[typeId.toLowerCase()] = value
                    }
                    return acc
                }, {})
            }

            scheme.forEach((x) => {
                let preFillcode
                const { UF_PRE_FILL_CODE, UF_PRE_FILL_CODE_COMPANY, name, UF_MASK } = x
                preFillcode = UF_PRE_FILL_CODE || UF_PRE_FILL_CODE_COMPANY
                if (UF_PRE_FILL_CODE) {
                    const fmProps = getFmProps(candidate.fm)
                    target = { ...candidate, ...fmProps }
                }
                if (UF_PRE_FILL_CODE_COMPANY && company && requisite) {
                    const fmProps = getFmProps(company?.fm)
                    target = { ...company, ...requisite, ...fmProps }
                }
                if (preFillcode) {
                    preFillcode = preFillcode.replaceAll('_', '').toLowerCase()
                    Object.entries(target).forEach(([defaultProp, value]) => {
                        defaultProp = defaultProp.replaceAll('_', '').toLowerCase()
                        if (preFillcode === defaultProp && value) {
                            result.push({
                                name,
                                value,
                                mask: UF_MASK,
                            })
                        }
                    })
                }
            })
            return result
        }
        const fillValues = ({ prefilled }) => {
            let updatedScheme = []

            const currentValues = getValues()

            const updateValue = (name, value) => {
                setValue(name, value, { shouldValidate: true })
                updatedScheme = scheme.map((x) => {
                    if (x.name === name) {
                        x.autofilled = true
                        x.value = value
                    }
                    return x
                })
            }

            prefilled.forEach(({ name, value, mask }) => {
                if (mask === 'tel') {
                    const { conformedValue } = conformToMask(value, telMask())
                    if (conformedValue) {
                        value = conformedValue
                    }
                }
                if (currentValues) {
                    if (!currentValues[name]) {
                        updateValue(name, value)
                    }
                } else {
                    updateValue(name, value)
                }
            })

            setTimeout(() => {
                setScheme(updatedScheme)
            })
        }
        const prefilled = getPrefilledValues()
        fillValues({ prefilled })
    }

    const getUtmFromUrl = () => {
        return [...new URLSearchParams(window.location.search)]
            .filter(([key, value]) => {
                return UTMLIST.find((x) => x.toLowerCase() === key.toLowerCase())
            })
            .reduce((acc, [key, value]) => {
                acc[key.toLowerCase()] = value
                return acc
            }, {})
    }

    useEffect(() => {
        const findCandidate = (items, values) => {
            return items.filter((item) => {
                let result = false
                for (const { code, value, mask } of values) {
                    if (value) {
                        let propForCompare = item[code].trim().toLowerCase()

                        if (mask === 'tel') {
                            const { conformedValue } = conformToMask(propForCompare, telMask())
                            if (conformedValue) {
                                propForCompare = conformedValue
                            }
                        }

                        const match = propForCompare === value.trim().toLowerCase()

                        if (match) {
                            result = true
                        } else {
                            result = false
                            break
                        }
                    }
                }
                return result
            })
        }

        let subscription
        let canidates = defaultValues || []
        canidates = canidates.map((x) => topLevelPropsToLowercase(x))

        if (canidates.length) {
            if (canidates.length === 1) {
                const [candidate] = canidates
                setCandidate(candidate)
            } else {
                subscription = watch((currentValues, { name, type }) => {
                    if (getFieldByName(name)) {
                        const values = namesForWatching.map(({ name, code, mask }) => ({
                            name,
                            mask,
                            code: code.replace('_', '').toLowerCase(),
                            value: currentValues[name],
                        }))
                        const filteredCandidates = findCandidate(canidates, values)
                        if (filteredCandidates.length === 1) {
                            const [candidate] = filteredCandidates
                            setCandidate(candidate)
                            subscription.unsubscribe()
                        }
                    }
                })
            }
        }
        return () => subscription && subscription.unsubscribe()
    }, [watch, defaultValues])

    useEffect(() => {

        let subscription
        let prevValue

        const disableEmail = (flag) => {
            const upd = scheme.map((x) => {
                if (x.UF_PRE_FILL_CODE == 'EMAIL') {
                    return { ...x, disabled: flag }
                } else {
                    return x
                }
            })
            setScheme(upd)
        }

        if (PHONE_AND_EMAIL_AUTOSEARCH && !defaultValues?.length) {
            const { name: phoneName, mask } = namesForWatching.find((x) => x.code == 'PHONE') || {}
            subscription = subscribe({
                name: [phoneName],
                formState: {
                    values: true,
                    isValid: true,
                },
                callback: async (props) => {
                    const { values } = props
                    const phoneValue = values[phoneName]
                    await Promise.resolve()
                    setTimeout(async () => {
                        const { invalid } = getFieldState(phoneName)
                        disableEmail(invalid)
                        if (!invalid) {
                            if (prevValue !== phoneValue) {
                                if (!mask && phoneValue.replace(/\D/g, '').length !== 11) return
                                const { unsubscribe } = await getCandidate({ phone: phoneValue })
                                if (unsubscribe) {
                                    subscription()
                                }
                                prevValue = phoneValue
                            }
                        }
                    })
                },
            })

            disableEmail(true)
        }

        return () => subscription && subscription()
    }, [subscribe])

    useEffect(() => {
        const checkDeps = (currentValues) => {
            const compare = ({ type, a, b }) => {
                const map = {
                    '=': a == b,
                    '!=': a != b,
                    '>': a > b,
                    '<': a < b,
                }
                return map[type]
            }

            const upds = scheme.map((item) => {
                const { DEPENDENCIES } = item
                if (DEPENDENCIES) {
                    for (const deps of item.DEPENDENCIES) {
                        const { UF_QUESTION_ID, UF_TYPE, UF_VALUE } = deps
                        const { name } = scheme.find((x) => x.ID === UF_QUESTION_ID)
                        if (compare({ type: UF_TYPE, a: currentValues[name], b: UF_VALUE })) {
                            item.UF_HIDDEN = false
                        } else {
                            item.UF_HIDDEN = true
                            break
                        }
                    }
                }
                return item
            })
            setScheme(upds)
        }
        const subscription = watch((currentValues, it) => {
            checkDeps(currentValues)
        })
        return () => subscription && subscription.unsubscribe()
    }, [watch])

    useEffect(() => {
        ;(async () => {
            if (candidate) {
                const items = (await getCompanyByContactId({ contact: candidate.id, scheme: id })) || []
                //  const data = (await (candidate.companyids)) || []
                //  const company = getMainCompany(data)

                let autofillPayload = {candidate}

                if(items && items.length) {
                    const  { requisite, ...company } = getMainCompany(items)

                    if (company) {
                        setCompany(company)
                    } else {
                        setCompany(null)
                    }

                    autofillPayload.requisite = requisite
                    autofillPayload.company = company
                }

                //  let [requisite] = (await getCompanyRequisites(candidate.companyid)) || []
                //  requisite = Object.fromEntries(Object.entries(requisite || {}).filter(([key]) => key.includes('RQ_')))
                // const requisite={}

                autoFill(autofillPayload)
            }
        })()
    }, [candidate])

    useEffect(() => {
        ref.current.addEventListener('keydown', (e) => {
            if (e.key === 'Tab') {
                e.preventDefault()
            }
        })
    }, [ref])

    useEffect(() => {
        const scope = wrapperEl || containerEl
        const btn = scope?.querySelector('.btn-reg-link')
        if (btn) {
            let href = btn.getAttribute('href')
            if (/forms/.test(href)) {
                const params = Object.entries(getUtmFromUrl() || {}).reduce((acc, [key, value]) => {
                    acc += `&${key}=${value}`
                    return acc
                }, '')
                if (params) {
                    href += params
                    btn.setAttribute('href', href)
                }
            }
        }
    }, [wrapperEl, containerEl])




    return (
        <>
            <form
                ref={ref}
                onSubmit={handleSubmit(onSubmitHandler)}
                noValidate
                autoComplete="off"
                className="content-block main-form"
                tabIndex={1}
            >
                <div className="main-form__title">{isTildaPopup ? (formPopupTitle || 'Форма регистрации') : (formTitle || 'Форма регистрации') }</div>
                <div className="main-form__subtitle">{isTildaPopup ? (formPopupSubTitle || 'Для участия в мероприятии заполните форму ниже') : (formSubTitle || 'Для участия в мероприятии заполните форму ниже')}</div>
                <Loader active={submitLoading}></Loader>
                <div className="main-form__fields">
                    {scheme.map((x, index) => {
                        const autoSearch = x.UF_AUTO_SEARCH
                        const hidden = x.UF_HIDDEN
                        return (
                            <div
                                key={x.ID}
                                className={`main-form__field ${
                                    (isHiddenFields && !autoSearch) || hidden ? 'hidden' : ''
                                }`}
                            >
                                <Field {...x} useFormContext={useFormContext}></Field>
                            </div>
                        )
                    })}
                    <div className={`main-form__field ${isHiddenFields ? 'hidden' : ''}`}>
                        <Field
                            UF_OBLIGATORY={true}
                            id="FIELD_POLICY"
                            name="FIELD_POLICY"
                            UF_FIELD_TYPE="checkbox"
                            text={checkboxHtml}
                            useFormContext={useFormContext}
                        ></Field>
                    </div>
                </div>
                {!!scheme.length && (
                    <>
                        {isHiddenFields ? (
                            <div className="main-form__footer">
                                <button onClick={getCandidateByEmail} className="btn btn--primary">
                                    Далее
                                </button>
                            </div>
                        ) : (
                            <div className="main-form__footer">
                                <button type="submit" className="btn btn--primary">
                                    Отправить
                                </button>
                            </div>
                        )}
                    </>
                )}
            </form>
            <Modal isOpen={modal} onClose={() => setModal(false)} title="Форма успешно отправлена">
                <div className="modal-success">
                    {successText && <div dangerouslySetInnerHTML={{ __html: successText }}></div>}
                    <button onClick={() => setModal(false)} className="btn btn--primary">
                        Мне все понятно
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default Form
